import { initializeApp } from "firebase/app";
import {getFirestore} from "firebase/firestore";
import {getAuth} from "firebase/auth"
import {getStorage} from "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyBIEiP1j3FroDe630xtdUEEqa_op7T5Kq8",
  authDomain: "first-web-project-17908.firebaseapp.com",
  projectId: "first-web-project-17908",
  storageBucket: "first-web-project-17908.appspot.com",
  messagingSenderId: "1069523932498",
  appId: "1:1069523932498:web:07aa1d70589be0228e168b"
};

const app = initializeApp(firebaseConfig)
  
export const db = getFirestore(app)
export const auth = getAuth(app);
export const storage = getStorage(app)

export default app;
